import React, { useEffect, useState } from 'react';

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function highlightQuote(text, quote) {
  if (!quote || !text.includes(quote)) return [text];
  const idx = text.indexOf(quote);
  return [
    text.slice(0, idx),
    <mark key="q" data-testid="evidence-highlight">{quote}</mark>,
    text.slice(idx + quote.length),
  ];
}

export default function ConversationModal({ alertId, onClose }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await fetch(`/api/teacher/alerts/${alertId}/conversation`, {
          credentials: 'include',
          headers: authHeaders(),
        });
        if (!res.ok) {
          if (active) setError(`HTTP ${res.status}`);
          return;
        }
        const body = await res.json();
        if (active) setData(body);
      } catch (e) {
        if (active) setError(String(e.message || e));
      }
    })();
    return () => { active = false; };
  }, [alertId]);

  if (error) {
    return (
      <div role="dialog" className="modal">
        <p>불러오기 실패: {error}</p>
        <button onClick={onClose}>닫기</button>
      </div>
    );
  }
  if (!data) return <div role="dialog" className="modal">로딩…</div>;

  const quote = data.alert.evidenceQuote;
  return (
    <div role="dialog" className="modal">
      <h3>대화 상세</h3>
      <div className="conversation">
        {data.messages.map((m, i) => (
          <div key={i} className={`msg msg--${m.sender}`}>
            <span className="msg__sender">{m.sender === 'user' ? '학생' : 'AI'}</span>
            <span className="msg__body">{highlightQuote(m.message, quote)}</span>
          </div>
        ))}
      </div>
      <button type="button" onClick={onClose}>닫기</button>
    </div>
  );
}
